import { Dataset } from '~/packages/general/system/bulk/systemBulk.data'
import { parseDateTime, stringifyDateTime } from '~/prix/types/dateTime'
import clearString from '~/prix/utils/bulk/clearString'

const citizen: Dataset = {
  schema: 'public_health',
  table: 'citizen',
  columnTransformMap: {
    original_id: original => original,
    cpf: original => original,
    cns: original => original,
    name: original => clearString(original as string),
    social_name: original => clearString(original as string),
    birth_date: original => (original ? original : null),
    sex: original => clearString(original as string),
    gender_identity: original => clearString(original as string),
    phone_number: original => original,
    cell_phone_number: original => original,
    deceased: original => (original === 'true' ? true : false),
    health_unit_cnes: original => original,
    team_ine: original => original,
    street_name: original => (original ? (original as string).toUpperCase() : null),
    street_number: original => original,
    street_type: original => (original ? (original as string).toUpperCase() : null),
    complement: original => (original ? (original as string).toUpperCase() : null),
    neighborhood: original => clearString(original as string),
    reference_point: original => clearString(original as string),
    municipality: original => clearString(original as string),
    postal_code: original => original,
    death_date: original => (original ? original : null),
    created_at: original => stringifyDateTime(parseDateTime(original as string)),
    updated_at: original => stringifyDateTime(parseDateTime(original as string)),
  },
}

export default citizen
